export default "__VITE_ASSET__7cc56608__"